import { useSelector, /* useDispatch  */ } from 'react-redux'
import { Row } from "react-bootstrap";
import { useState, /* useRef, */ useEffect } from 'react';
import { /* Button, Input, Space, */ Table, Form, /* InputNumber, */ Empty } from 'antd';
// import { getStyle } from '../../libs/todoSlice'
import { getHistoryDetail } from '../../../../libs/historySlice';
const StudentHistoryDetailSuccess = () => {
    const details = useSelector(getHistoryDetail)
    const [form] = Form.useForm();
    const [data, setData] = useState([]);
    const [objective, setObjective] = useState([]);
    useEffect(() => {
        
        setObjective(details.importHistories[details.importHistories.length - 1].objective)
        setData(details.importHistories[details.importHistories.length - 1].successDetail.map((items, index) => {
            return {
                loading: false,
                // contract_no: items.request.contract_no ?? '-',
                // title_th: items.request.title_th ?? '-',
                // title_special_th: items.request.title_special_th ?? '-',
                // employee_id: items.request.employee_id ?? '-',
                // name_th: items.request.name_th ?? '-',
                // surname_th: items.request.surname_th ?? '-',
                // name_eng: items.request.name_eng ?? '-',
                // surname_eng: items.request.surname_eng ?? '-',
                // cid: items.request.cid ?? '-',
                // address: items.request.address ?? '-',
                // tel: items.request.tel ?? '-',
                // mobile: items.request.mobile ?? '-',
                // email: items.request.email ?? '-',
                // position: items.request.position ?? '-',
                // sub_organization: items.request.sub_organization ?? '-',
                // organization: items.request.organization ?? '-',
                // tax_id: items.request.tax_id ?? '-',
                // maintainer_name_1: items.request.maintainer_name_1 ?? '-',
                // maintainer_surname_1: items.request.maintainer_surname_1 ?? '-',
                // maintainer_name_2: items.request.maintainer_name_2 ?? '-',
                // maintainer_surname_2: items.request.maintainer_surname_2 ?? '-',
                // maintainer_email_1: items.request.maintainer_email_1 ?? '-',
                // maintainer_email_2: items.request.maintainer_email_2 ?? '-',
                // maintainer_tel_1: items.request.maintainer_tel_1 ?? '-',
                // maintainer_tel_2: items.request.maintainer_tel_2 ?? '-',
                // id_card_type: items.request.id_card_type,
                // room_no: items.request.room_no,
                // house_no: items.request.house_no,
                // moo: items.request.moo,
                // floor: items.request.floor,
                // street: items.request.street,
                // building_name: items.request.building_name,
                // alley: items.request.alley,
                // start_year: items.request.start_year,
                // end_year: items.request.end_year,
                // middle_name_th: items.request.middle_name_th,
                // middle_name_eng: items.request.middle_name_eng,
                // special_title_th: items.request.special_title_th,
                // special_title_eng: items.request.special_title_eng,
                // degree: items.request.degree,
                // major: items.request.major,
                // faculty: items.request.faculty,
                // minor: items.request.minor,
                // status: items.request.status,
                // sub_district: items.request.sub_district,
                // district: items.request.district,
                // province: items.request.province,
                // zipcode: items.request.zipcode,
                // student_id: items.request.student_id,
                // birth_date: items.request.birth_date,
                // username: items.request.username,
                // password: items.request.password,
                index: index + 1,
                status: items.request.status,
                degree: items.request.degree,
                faculty: items.request.faculty,
                major: items.request.major,
                minor: items.request.minor,
                id_card_type: items.request.id_card_type,
                cid: items.request.cid,
                tel: items.request.tel,
                student_id: items.request.student_id,
                email: items.request.email,
                birth_date: items.request.birth_date,
                title_th: items.request.title_th,
                special_title_th: items.request.special_title_th ?? "-",
                name_th: items.request.name_th,
                middle_name_th: items.request.middle_name_th ?? "-",
                surname_th: items.request.surname_th,
                title_en: items.request.title_en,
                special_title_eng: items.request.special_title_eng ?? "-",
                name_eng: items.request.name_eng,
                middle_name_eng: items.request.middle_name_eng ?? "-",
                surname_eng: items.request.surname_eng

            }
        }))
    }, [])

    const customLocale = {
        emptyText: (<Empty
            description="ไม่มีข้อมูล"
        />)
    };
    const columns = [
        {
            title: 'ลำดับที่',
            width: 150,
            editable: true,
            show: true,
            render: (_, record, index) => record.index

            // fixed: 'left',
        },
        {
            title: (<> คำนำหน้า <br />(ภาษาไทย) </>),
            dataIndex: 'title_th',
            width: 150,
            show: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
        {
            title: (<> คำนำหน้าอื่นๆ <br />(ภาษาไทย) </>),
            dataIndex: 'special_title_th',
            width: 180,
            editable: true,
            show: true,
            // fixed: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('name_th'),
        },
        {
            title: (<> คำนำหน้าอื่นๆ <br />(ภาษาอังกฤษ) </>),
            dataIndex: 'special_title_eng',
            width: 180,
            editable: true,
            show: true,
            // fixed: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('name_th'),
        },
        {
            title: (<> ชื่อ <br />(ภาษาไทย) </>),
            dataIndex: 'name_th',
            width: 150,
            editable: true,
            show: true,
            // fixed: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
        {
            title: (<> ชื่อกลาง <br />(ภาษาไทย) </>),
            dataIndex: 'middle_name_th',
            width: 150,
            show: true,
            // width: '10%',
            editable: true,
            // fixed: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('name_th'),
        },
        {
            title: <> นามสกุล <br />(ภาษาไทย) </>,
            dataIndex: 'surname_th',
            width: 150,
            editable: true,
            show: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
        {
            title: (<> ชื่อ <br />(ภาษาอังกฤษ) </>),
            dataIndex: 'name_eng',
            width: 150,
            editable: true,
            show: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
        {
            title: (<> ชื่อกลาง <br />(ภาษาอังกฤษ) </>),
            dataIndex: 'middle_name_eng',
            width: 150,
            show: true,
            // width: '10%',
            editable: true,
            // fixed: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('name_th'),
        },
        {
            title: <> นามสกุล <br />(ภาษาอังกฤษ)</>,
            dataIndex: 'surname_eng',
            width: 150,
            editable: true,
            show: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
        {
            title: 'ประเภทบัตร',
            dataIndex: 'id_card_type',
            width: 180,
            show: true,
            // fixed: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
        {
            title: 'เลขประจำตัวประชาชน',
            dataIndex: 'cid',
            width: 150,
            editable: true,
            show: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
        {
            title: 'ระดับการศึกษา',
            dataIndex: 'degree',
            width: 180,
            editable: true,
            show: true,
            // fixed: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('name_th'),
        },
        {
            title: 'คณะ',
            dataIndex: 'faculty',
            width: 180,
            editable: true,
            show: true,
            // fixed: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('name_th'),
        },
        {
            title: 'Major (สาขา/ภาควิชา)',
            dataIndex: 'major',
            width: 180,
            editable: true,
            show: true,
            // fixed: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('name_th'),
        },
        {
            title: 'Minor (ถ้ามี)',
            dataIndex: 'minor',
            width: 180,
            editable: true,
            show: true,
            // fixed: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('name_th'),
        },
        {
            title: 'สถานะการศึกษา',
            dataIndex: 'status',
            width: 180,
            editable: true,
            show: true,
            // fixed: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('name_th'),
        },
        {
            title: 'โทรศัพท์',
            dataIndex: 'tel',
            width: 150,
            editable: true,
            show: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
        {
            title: 'อีเมล',
            dataIndex: 'email',
            width: 250,
            editable: true,
            show: true,
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
        },
        {
            title: 'รหัสนักศึกษา',
            dataIndex: 'student_id',
            width: 180,
            editable: true,
            show: true,
            // fixed: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('name_th'),
        },
        {
            title: 'วันเกิด (ปปปป-ดด-วว)',
            dataIndex: 'birth_date',
            width: 180,
            editable: true,
            show: true,
            // fixed: 'left',
            responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
            // ...getColumnSearchProps('name_th'),
            render: (_) => {
                return <>{_}</>
            }
        },
    ].filter(head => head.show);
    return (
        <Row>
            {/* ui table */}
            <Form form={form} component={false}>
                <Table
                    locale={customLocale}
                    bordered
                    dataSource={data}
                    columns={columns}
                    rowClassName="editable-row"
                    agination={{ pageSize: 25, }}
                    scroll={{
                        x: 1400,
                        y: 400,
                    }}

                />
            </Form>
            {/* end ui table */}
        </Row>
    )
}
export default StudentHistoryDetailSuccess